import { Link, useNavigate } from "react-router-dom";
import Logo from "../assets/img/skor-white-logo.svg";
import Flag from "../assets/img/flag.svg";
import AuthContext from "../context/auth/AuthContext";
import { useContext, useRef, useState, useCallback } from "react";
import { haveValue, validatePhoneNumber } from "../helper/common";
import eyeicon from "../assets/img/eye.png";
import logouticon from "../assets/img/logout.png";
import downIcon from "../assets/img/down-icon-dark.svg";
import useTranslator from "../hooks/useTranslator";
import { Modal } from "react-bootstrap";
import QRCode from "react-qr-code";
import copy from "copy-to-clipboard";
import { toast } from "react-toastify";
import { FaRegCopy } from "react-icons/fa6";
import { IoMdDownload } from "react-icons/io";
import PhoneInput from "react-phone-input-2";
import LandLordContext from "../context/landlord/LandLordContext";
import i18next from "i18next";
function downloadBlob(blob, filename) {
  const objectUrl = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = objectUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  setTimeout(() => URL.revokeObjectURL(objectUrl), 5000);
}

const Header = () => {
  const { _t } = useTranslator();
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [showInviteTenantModel, setShowInviteTenantModel] = useState(false);
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [showPhoneModal, setShowPhoneModal] = useState(false);
  const [agencyDetails, setAgencyDetails] = useState(null);
  const [sharerEmail, setSharerEmail] = useState(null);
  const [sharerPhone, setSharePhone] = useState(null);
  const [sharerName, setSharerName] = useState(null);
  const { sendInvitationToTenant } = useContext(LandLordContext);
  const [currentLang, setCurrentLang] = useState(
    localStorage.getItem("i18nextLng").toLowerCase() || "en-us"
  );
  const svgRef = useRef();
  const authContext = useContext(AuthContext);
  const { userType, user, logout, changeUserLng } = authContext;
  const takeMeToProfile = () => {
    navigate(`/${userType}-profile`);
  };

  const handlecopyUrl = () => {
    copy(
      `https://${process.env.REACT_APP_URL_NAME}/home?requestProfileLink=${user?._id}`
    );
    toast.success(_t("linkCopied"));
  };

  const handleDownloadQR = useCallback(() => {
    const svg = svgRef.current.innerHTML;
    const blob = new Blob([svg], { type: "image/svg+xml" });
    downloadBlob(blob, `myimage.svg`);
  }, []);

  const sendInvitationViaEmail = async (e) => {
    e.preventDefault();
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(sharerEmail)) {
      try {
        const response = await sendInvitationToTenant({
          type: "email",
          name: sharerName,
          email: sharerEmail,
        });
        const data = response.data;
        if (data.message) {
          toast.success(data.message);
        }
      } catch (error) {
        const response = error.response;
        if (response.data) {
          if (response.data.err) {
            toast.error(response.data.err);
          }
        }
      } finally {
        setSharerEmail(null);
        setShowEmailModal(false);
      }
    } else {
      toast.error(_t("invalidEmailAddress"));
      return false;
    }
  };

  const sendInvitationViaPhone = async (e) => {
    e.preventDefault();
    const validate = validatePhoneNumber(sharerPhone);
    if (!validate.isValid) {
      toast.error(validate.message);
      return false;
    } else {
      try {
        const response = await sendInvitationToTenant({
          type: "phone",
          name: sharerName,
          phone: sharerPhone,
        });
        const data = response.data;
        if (data.message) {
          toast.success(data.message);
        }
      } catch (error) {
        const response = error.response;
        if (response.data) {
          if (response.data.err) {
            toast.error(response.data.err);
          }
        }
      } finally {
        setSharePhone(null);
        setShowPhoneModal(false);
      }
    }
  };

  const handleLanguageChange = async (langVal) => {
    await i18next.changeLanguage(langVal);
    await changeUserLng();
    setCurrentLang(langVal);
  };

  return (
    <nav class="navbar navbar-expand-lg navbar-light z-1 position-static">
      <div class="container container-fluid navbar-container">
        <div className="row" style={{ alignItems: "center", width: "100%" }}>
          <div className="col-md-1">
            <Link to="/">
              <img src={Logo} alt="Skor Logo" style={{ height: "2.024vw" }} />
            </Link>
            <button
              class="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span class="navbar-toggler-icon"></span>
            </button>
          </div>
          <div className="col-md-6">
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
              <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                <li class="nav-item d-flex align-items-center">
                  <div>
                    <div class="megadropdown megadropdown2">
                      <button class="megadropdown-toggle" type="button">
                        {_t("tenant")}
                        <img
                          class="icon small_icon"
                          src="/images/icon-down-grey.svg"
                          alt=""
                        />
                      </button>
                      <div class="megadropdown-menu">
                        <Link
                          className="d-flex align-items-center gap-2"
                          to="/profile-request"
                        >
                          {_t("tenantProfiles")}
                          <img
                            class="icon small_icon"
                            src="/images/arrow-right-green.svg"
                            alt=""
                          />
                        </Link>
                        <Link
                          className="d-flex align-items-center gap-2"
                          to="/created-tenant"
                        >
                          {_t("tenantChecks")}
                          <img
                            class="icon small_icon"
                            src="/images/arrow-right-green.svg"
                            alt=""
                          />
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div class="megadropdown megadropdown2">
                      <button class="megadropdown-toggle" type="button">
                        {_t("properties")}
                        <img
                          class="icon small_icon"
                          src="/images/icon-down-grey.svg"
                          alt=""
                        />
                      </button>
                      <div class="megadropdown-menu">
                        <Link
                          className="d-flex align-items-center gap-2"
                          to="/home"
                        >
                          {_t("myProperties")}
                          <img
                            class="icon small_icon"
                            src="/images/arrow-right-green.svg"
                            alt=""
                          />
                        </Link>
                        <Link
                          className="d-flex align-items-center gap-2"
                          to="/payment/property/list"
                        >
                          {_t("propertiesPayments")}
                          <img
                            class="icon small_icon"
                            src="/images/arrow-right-green.svg"
                            alt=""
                          />
                        </Link>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div className="col-md-5 d-flex language-switch-wrapper">
            <div className="shareQr">
              <a
                className="btn btngreen invite_tenantbtn"
                href={undefined}
                onClick={(e) => setShowInviteTenantModel(true)}
              >
                <img
                  className="invite-tenant-icon"
                  src="/images/invite-tenant-icon.svg"
                  alt=""
                />
                {_t("requestProfile")}
              </a>
            </div>

            {currentLang == "es" ? (
              <div
                className="language-switch-container language-switch-container-es  cursor-pointer"
                onClick={(e) => handleLanguageChange("en-us")}
              >
                <p>ES</p>
                <img
                  className="flag-image"
                  alt="Flag"
                  src="/images/spain-flag.png"
                />
              </div>
            ) : (
              <div
                className="language-switch-container cursor-pointer"
                onClick={(e) => handleLanguageChange("es")}
              >
                <img className="flag-image" alt="Flag" src={Flag} />
                <p>EN</p>
              </div>
            )}
            <div className="slideryt">
              <div className="re-div">
                <div className="dropdown admin-btn">
                  <Link data-bs-toggle="dropdown">
                    <div className="d-flex">
                      <div className="admin-name header-admin-name">
                        {userType == "landlord" ? (
                          haveValue(agencyDetails) &&
                          haveValue(agencyDetails?.company_name) &&
                          haveValue(agencyDetails?.company_logo) ? (
                            <img
                              id="navbar_ll_image"
                              src={`${process.env.REACT_APP_SERVER_URL}/uploads/${agencyDetails?.company_logo}`}
                              alt=""
                            />
                          ) : (
                            <>
                              {user?.fname_companyName &&
                                user?.fname_companyName.charAt(0).toUpperCase()}
                              {user?.lname &&
                                user?.lname.charAt(0).toUpperCase()}
                            </>
                          )
                        ) : (
                          <>
                            {user?.fname && user?.fname.charAt(0).toUpperCase()}
                            {user?.lname && user?.lname.charAt(0).toUpperCase()}
                          </>
                        )}
                      </div>
                      <img src={downIcon} alt="arrow-down" className="ms-2" />
                    </div>

                    <ul className="dropdown-menu">
                      <div
                        className="hover-dropdown"
                        style={{ display: "block" }}
                      >
                        <Link onClick={takeMeToProfile}>
                          <img src={eyeicon} alt="" /> {_t("viewProfile")}
                        </Link>
                        <Link
                          className="pb-0"
                          onClick={(e) => setShowModal(true)}
                        >
                          <img src={logouticon} alt="" /> {_t("logout")}
                        </Link>
                      </div>
                    </ul>
                  </Link>
                </div>
                {/* <div className="hover-dropdown">
                              <a href="#" className="mt-1"><img src="./img/eye.png" alt=""/> View Profile</a>
                              <a href="#"><img src="./img/logout.png" alt=""/> Log Out</a>
                           </div> */}
              </div>
              <Modal
                show={showModal}
                centered
                className="newmodalui asguarantor"
              >
                <Modal.Header></Modal.Header>
                <Modal.Body>
                  <div className="forminput row100">
                    {_t("areYouSureYouWantToLogout")}
                  </div>
                  <div className="btngroup row100 gridbar">
                    <button
                      className="btn btnoutline cancel-btn"
                      type="button"
                      onClick={(e) => setShowModal(false)}
                    >
                      {_t("cancel")}
                    </button>
                    <button
                      className="btn btnorange"
                      type="button"
                      onClick={logout}
                    >
                      {_t("logout")}
                    </button>
                  </div>
                </Modal.Body>
              </Modal>
              <Modal
                show={showInviteTenantModel}
                onHide={(e) => setShowInviteTenantModel(false)}
                centered
                className="newmodalui max-w-lg"
              >
                <Modal.Header closeButton>
                  <Modal.Title>{_t("yourProfileQR")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <div className="qr-code-div qrcode-copy" ref={svgRef}>
                    <QRCode
                      id="qr_code_image"
                      value={`https://${process.env.REACT_APP_URL_NAME}/home?requestProfileLink=${user?._id}`}
                    />
                  </div>
                  <div className="qr-link-copi share-and-copy-div">
                    <input
                      type="text"
                      disabled
                      value={`https://${process.env.REACT_APP_URL_NAME}/home?requestProfileLink=${user?._id}`}
                    />
                    <button type="button" onClick={handlecopyUrl}>
                      <FaRegCopy />
                      {_t("copyURL")}
                    </button>
                  </div>
                  <div className="qr-code-download">
                    <a href={undefined} onClick={handleDownloadQR}>
                      <IoMdDownload />
                      {_t("downloadNow")}
                    </a>
                  </div>
                  <div className="d-flex justify-content-center gap-2 align-items-center m-3">
                    <button
                      type="button"
                      onClick={() => {
                        setShowEmailModal(true);
                        setShowInviteTenantModel(false);
                      }}
                      className="btn btngreen"
                    >
                      {_t(
                        "shareViaEmail",
                        "Landlord side in tenant profile section"
                      )}
                    </button>
                    <button
                      type="button"
                      onClick={() => {
                        setShowPhoneModal(true);
                        setShowInviteTenantModel(false);
                      }}
                      className="btn btngreen"
                    >
                      {_t(
                        "shareViaPhone",
                        "Landlord side in tenant profile section"
                      )}
                    </button>
                  </div>
                </Modal.Body>
              </Modal>
              <Modal
                show={showEmailModal}
                onHide={(e) => setShowEmailModal(false)}
                centered
                className="newmodalui max-w-lg"
              >
                <Modal.Header closeButton>
                  <Modal.Title>{_t("email")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  {/* <div className="qr-link-copi"> */}
                  <form
                    onSubmit={sendInvitationViaEmail}
                    className="d-flex flex-wrap mt-5 justify-content-center"
                  >
                    <div className="form-group col-6 px-1 bodyContentset">
                      <input
                        type="text"
                        onChange={(e) => {
                          setSharerName(e.target.value);
                        }}
                        className="form-control"
                        required={true}
                        placeholder={_t("name")}
                      />
                    </div>
                    <div className="form-group col-6 px-1 bodyContentset">
                      <input
                        type="email"
                        onChange={(e) => {
                          setSharerEmail(e.target.value);
                        }}
                        className="form-control"
                        required={true}
                        placeholder={_t("email")}
                      />
                    </div>
                    <div className="col-12 mt-3  d-flex justify-content-center">
                      <button type="submit" className="btn btngreen">
                        {_t("sendInvitation")}
                      </button>
                    </div>
                  </form>
                  {/* </div> */}
                </Modal.Body>
              </Modal>
              <Modal
                show={showPhoneModal}
                onHide={(e) => setShowPhoneModal(false)}
                centered
                className="newmodalui max-w-lg"
              >
                <Modal.Header closeButton>
                  <Modal.Title>{_t("phone")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <form
                    onSubmit={sendInvitationViaPhone}
                    className="d-flex flex-wrap mt-5 justify-content-center"
                  >
                    <div className="form-group col-6 px-1 bodyContentset">
                      <input
                        type="text"
                        onChange={(e) => {
                          setSharerName(e.target.value);
                        }}
                        className="form-control"
                        required={true}
                        placeholder={_t("name")}
                      />
                    </div>
                    <div className="form-group col-6 px-1 bodyContentset">
                      <PhoneInput
                        className="custom-input phone_input"
                        international
                        country={"es"}
                        value={sharerPhone}
                        onChange={(e) => setSharePhone(e)}
                      />
                    </div>
                    <div className="col-12 mt-3 d-flex justify-content-center">
                      <button type="submit" className="btn btngreen">
                        {_t("sendInvitation")}
                      </button>
                    </div>
                  </form>
                </Modal.Body>
              </Modal>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Header;
